<template>
    <modal ref="modal" size="modal-lg" id="modalJitsi">
        <template #header>
            <div class="text-gray-777 font-roboto uppercase">
                <span>Consulta | {{ appointment.patient.user.name }}</span>
            </div>
            <div>
                <font-awesome-icon v-if="!collapsed" @click.prevent="collapse" icon="fa-square-minus" class="text-gray-500 text-lg cursor-pointer" />
                <font-awesome-icon v-if="collapsed" @click.prevent="expand" icon="fa-square-plus" class="text-gray-500 text-lg cursor-pointer" />
            </div>
        </template>
        <template #body>
            <div v-if="!loadJitsi" class="flex justify-center mb-5">
                <div class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
                </div>
            </div>
            <jitsi-meet :class="{hidden: !loadJitsi}"
            ref="jitsiRef"
            :options="jitsiOptions"
            ></jitsi-meet>
        </template>
    </modal>
</template>
<script>
import { ref, computed } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3'
import Modal from '@/Shared/Modal/Modal'
import JitsiMeet from '@/Shared/Components/JitsiMeet'
import draggable from 'vuedraggable'

export default {
    data() {
        return {
            loadJitsi: false,
            collapsed: false,
        }
    },
    components: {
        Modal,
        JitsiMeet,
        draggable,
    },
    props: {
        processing: {
            type: Boolean,
            default: false
        },
        appointment: {
            type: Object
        },
        modalScrollable: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, context) {
        const user = computed(() => usePage().props.value.auth.user)

        const appointment = ref(props.appointment);

        const modal = ref(null);

        const closeModalJitsi = () => {
            modal.value.showModal = false;
        }

        return {
            user,
            closeModalJitsi,
            modal,
            appointment,
        }
    },
    methods: {
        openModalJitsi(a) {
            if(this.$refs.modal.$el.querySelector('.modal-body div')) {
                this.$toast.error('Encerre a consulta atual para iniciar uma nova.');
            } else {
                this.loadJitsi = false;
                this.appointment = a;
                this.$refs.modal.showModal = true;
            }
        },
        collapse() {
            this.collapsed = true;
            this.$refs.modal.$el.querySelector('.backdrop').classList.add('hidden');
            this.$refs.modal.$el.querySelector('.modal').classList.remove('h-full');
            this.$refs.modal.$el.querySelector('.modal').classList.remove('w-full');
            this.$refs.modal.$el.querySelector('.modal').classList.remove('top-0');
            this.$refs.modal.$el.querySelector('.modal').classList.remove('left-0');
            this.$refs.modal.$el.querySelector('.modal').classList.remove('overflow-x-hidden');
            this.$refs.modal.$el.querySelector('.modal').classList.remove('overflow-y-auto');
            this.$refs.modal.$el.querySelector('.modal').classList.add('left-[20px]');
            this.$refs.modal.$el.querySelector('.modal').classList.add('bottom-0');
            this.$refs.modal.$el.querySelector('.modal-content').classList.remove('shadow-lg');
            this.$refs.modal.$el.querySelector('.modal-content').classList.add('shadow_box');
            this.$refs.modal.$el.querySelector('.modal-content').classList.remove('h-[500px]');
            this.$refs.modal.$el.querySelector('.modal-content').classList.add('h-[250px]');
            document.body.classList.remove("modal-open");
        },
        expand() {
            this.collapsed = false;
            this.$refs.modal.$el.querySelector('.backdrop').classList.remove('hidden');
            this.$refs.modal.$el.querySelector('.modal').classList.remove('left-[20px]');
            this.$refs.modal.$el.querySelector('.modal').classList.remove('bottom-0');
            this.$refs.modal.$el.querySelector('.modal').classList.add('h-full');
            this.$refs.modal.$el.querySelector('.modal').classList.add('w-full');
            this.$refs.modal.$el.querySelector('.modal').classList.add('top-0');
            this.$refs.modal.$el.querySelector('.modal').classList.add('left-0');
            this.$refs.modal.$el.querySelector('.modal').classList.add('overflow-x-hidden');
            this.$refs.modal.$el.querySelector('.modal').classList.add('overflow-y-auto');
            this.$refs.modal.$el.querySelector('.modal-content').classList.remove('shadow_box');
            this.$refs.modal.$el.querySelector('.modal-content').classList.add('shadow-lg');
            this.$refs.modal.$el.querySelector('.modal-content').classList.remove('h-[250px]');
            this.$refs.modal.$el.querySelector('.modal-content').classList.add('h-[500px]');
        },
        open() {
            this.$refs.modal.showModal = true;
        },
        close() {
            this.$refs.modal.showModal = false;
        },
        onIFrameLoad() {
            this.loadJitsi = true;
            this.$refs.modal.$el.querySelector('.modal-content').classList.add('h-[500px]');
            this.$refs.modal.$el.querySelector('.modal-body').classList.remove('mb-4');
            this.$refs.modal.$el.querySelector('.modal-body').classList.remove('mt-4');
            this.$refs.jitsiRef.addEventListener('readyToClose', this.closeConsultation);
            setTimeout(() => {
                this.$refs.jitsiRef.executeCommand('setTileView', true);
            }, 1000);
            fetch(
                "/patients/appointments/update-join-date/" + this.appointment.id
            ).then(res => {
            });
        },
        closeConsultation() {
            this.$refs.modal.showModal = false;
            this.collapsed = false;
            this.loadJitsi = false;
        },
    },
    computed: {
        jitsiOptions() {
            return {
                roomName: this.appointment.id.replaceAll('-', ''),
                jwt: this.appointment.jwt,
                lang: 'ptBR',
                noSSL: false,
                userInfo: {
                    email: this.user.email,
                    displayName: this.user.name,
                },
                configOverwrite: {
                    toolbarButtons: [
                        'camera',
                        'chat',
                        'desktop',
                        'fullscreen',
                        'microphone',
                        'raisehand',
                        'select-background',
                        'settings',
                        'tileview',
                        'toggle-camera',
                        'videoquality',
                        'hangup',
                    ],
                },
                onload: this.onIFrameLoad
            };
        },
    },
}
</script>
<style>
    
</style>